type Member = {
  person_id: number;
  first_name: string;
  last_name: string;
  nickname: string;
  unit_id: number;
  unit_display_name: string;
  date_of_birth: string;
  role: string;
};

export default function memberList(node: HTMLElement): void {
  const memberListContainer_ =
    node.querySelector<HTMLElement>('[data-member-list]');
  if (!memberListContainer_) {
    console.error('Member list container not found');
    return;
  }
  const memberListContainer = memberListContainer_;

  const input_ = node.querySelector<HTMLInputElement>('[data-members-input]');
  if (!input_) {
    console.error('Members input not found');
    return;
  }
  const input = input_;

  // Find the dialog and its form
  const dialog = document.querySelector<HTMLDialogElement>('#addMemberDialog');
  const dialogForm = dialog?.querySelector<HTMLFormElement>(
    '[data-add-member-form]',
  );
  if (dialog && !dialogForm) {
    console.error('Add member form not found');
    return;
  }

  // Find the main form
  const mainForm = node.closest('form');
  if (!mainForm) {
    console.error('Main form not found');
    return;
  }

  // Copy form data from main form to dialog form before submission
  dialogForm?.addEventListener('submit', (_e) => {
    // Copy all values from main form to dialog form's hidden fields
    const copyFields =
      dialogForm.querySelectorAll<HTMLInputElement>('[data-copy-field]');
    copyFields.forEach((field) => {
      const fieldName = field.getAttribute('data-copy-field');
      if (!fieldName) return;

      const mainFormField = mainForm.querySelector<HTMLInputElement>(
        `[name="${fieldName}"]`,
      );
      if (mainFormField) {
        field.value = mainFormField.value;
      }
    });
  });

  // Helper to update the JSON in the hidden input
  function updateMembersJson(): void {
    const members: Member[] = [];
    memberListContainer
      .querySelectorAll<HTMLElement>('[data-person-id]')
      .forEach((memberElement) => {
        const personIdStr = memberElement.getAttribute('data-person-id');
        if (!personIdStr) return;

        const personId = parseInt(personIdStr, 10);
        const roleSelect =
          memberElement.querySelector<HTMLSelectElement>('[data-member-role]');

        if (!roleSelect) return;

        // Find the member data in the current JSON to preserve all fields
        const currentMembers: Member[] = JSON.parse(input.value || '[]');
        const currentMember = currentMembers.find(
          (m) => m.person_id === personId,
        );

        if (currentMember) {
          members.push({
            ...currentMember,
            role: roleSelect.value,
          });
        }
      });

    const newValue = JSON.stringify(members);
    if (newValue !== input.value) {
      input.value = newValue;
      // Dispatch change event to notify any listeners
      const event = new Event('change', { bubbles: true });
      input.dispatchEvent(event);
    }
  }

  // Add event listeners to all role selects
  memberListContainer
    .querySelectorAll<HTMLSelectElement>('[data-member-role]')
    .forEach((select) => {
      select.addEventListener('change', () => {
        updateMembersJson();
      });
    });

  // Add event listeners to all remove buttons
  memberListContainer
    .querySelectorAll<HTMLButtonElement>('[data-remove-member]')
    .forEach((button) => {
      button.addEventListener('click', () => {
        const memberElement = button.closest<HTMLElement>('[data-person-id]');
        if (memberElement) {
          memberElement.remove();
          updateMembersJson();
        }
      });
    });
}
